// eslint-disable-next-line no-shadow
export enum CompanyFeatures {
  TRANSACTION_SUMMARY = "TRANSACTION_SUMMARY",
  FORECAST = "FORECAST",
  ALLOWANCE_DELIVERY = "ALLOWANCE_DELIVERY",
  ALLOWANCE_ALERTS = "ALLOWANCE_ALERTS",
  THRESHOLD_ALERT = "THRESHOLD_ALERT",
  WITHDRAW_FUNDS = "WITHDRAW_FUNDS",
  ALLOW_CHANGE_BENEFIT_MODEL = "ALLOW_CHANGE_BENEFIT_MODEL",
  PAYROLL_REPORT = "PAYROLL_REPORT",
  ANALYTICS_DASHBOARDS = "ANALYTICS_DASHBOARDS",
}
